import { Controller } from "@hotwired/stimulus";

// Reports one Umami event for the element it sits on (the umami_event helper writes its values). The once value
// is the session key that keeps a reload, or a return to the page, from reporting the same thing again.
export default class extends Controller {
  static values = { name: String, data: Object, once: String };

  connect() {
    // The tracker script loads after this bundle, so it is there only once the page has finished loading.
    if (document.readyState === 'complete') this.report();
    else window.addEventListener('load', () => this.report(), { once: true });
  }

  report() {
    if (!window.umami) return;
    try {
      if (sessionStorage.getItem(this.onceValue)) return;
      sessionStorage.setItem(this.onceValue, '1');
    } catch {
      // Without storage every reload would count again.
      return;
    }
    window.umami.track(this.nameValue, this.dataValue);
  }
}
